import React, { useEffect } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../../store/productSlice";
import Loader from "../../Common/Loader";
import StatusCode from "../../../Utils/StatusCode";
import ProductsCard from "../../Cards/ProductsCard";
import { da } from "date-fns/locale";
import { LuMoveRight } from "react-icons/lu";
import { useQuery, gql } from "@apollo/client";

const SIMILAR_MERCHANTS_PRODUCTS_QUERY = gql`
  query FetchSimilarMerchantProducts($productId: String!) {
    fetchSimilarMerchantProducts(
      query: { productId: $productId }
      pageOptions: { page: 1, limit: 15 }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        name
        alias
        description
        isNegotiable
        price
        weight
        quantityInStock
        isInStock
        images
        features
        boxContent
        rating
        status
        deletedAt
        totalViews
        merchant {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          imageUrl
          email
          phone
          sex
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
      }
    }
  }
`;

const SimilarMerchantsProducts = ({ productId }) => {
  const theme = useTheme();
  const isMobille = useMediaQuery(theme.breakpoints.down("md"));

  const { data, error, loading } = useQuery(SIMILAR_MERCHANTS_PRODUCTS_QUERY, {
    variables: {
      productId: productId,
    },
  });

  useEffect(() => {
    console.log("data:", data);
    console.log("error:", error);
    console.log("loading:", loading);

    if (error) {
      console.error("Error fetching similar merchant products:", error);
    }

    if (data) {
      const similarProducts = data.fetchSimilarMerchantProducts.items;
      console.log("Similar merchant products:", similarProducts);
    }
  }, [data, error, loading]);

  return (
    <>
      {loading === true && <Loader />}
      {data?.fetchSimilarMerchantProducts?.items?.length > 0 && (
        <Box
          sx={{
            p: 2,
            pb: 4,
            my: 3,
            mx: 0,
            bgcolor: " #f2f2f2",
            boxShadow:
              " rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
            borderRadius: "5px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: {
                  lg: "24px",
                  xs: "16px",
                  md: "24px",
                  sm: "18px",
                },
                fontWeight: 700,
              }}
            >
              Other products from this seller
            </Typography>
          </Box>
          <Box>
            {isMobille ? (
              <>
                <Grid container spacing={1} sx={{ mt: 3 }}>
                  {data?.fetchSimilarMerchantProducts?.items?.length === 0 ? (
                    <p>This merchant has no other products</p>
                  ) : (
                    data?.fetchSimilarMerchantProducts?.items
                      ?.slice(0, 10)
                      .map((product, index) => (
                        <Grid item sm={6} xs={6} key={product._id}>
                          <Link to={`/product-view/${product._id}`} key={index}>
                            <ProductsCard
                              image={product.images && product.images[0]}
                              price={product.price.toLocaleString()}
                              flag={product?.country?.flagUrl}
                              title={product?.name}
                              ratings={product?.rating}
                              description={product?.description}
                            />
                          </Link>
                        </Grid>
                      ))
                  )}
                </Grid>
              </>
            ) : (
              <>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  {data?.fetchSimilarMerchantProducts?.items?.length === 0 ? (
                    <p>This merchant has no other products</p>
                  ) : (
                    data?.fetchSimilarMerchantProducts?.items
                      .slice(0, 10)
                      .map((product, index) => (
                        <Grid
                          item
                          lg={1.5}
                          md={3}
                          sm={4}
                          xs={6}
                          key={product._id}
                        >
                          <Link to={`/product-view/${product._id}`} key={index}>
                            <ProductsCard
                              image={product.images && product.images[0]}
                              price={product.price.toLocaleString()}
                              flag={product?.country?.flagUrl}
                              title={product?.name}
                              ratings={product?.rating}
                              description={product?.description}
                            />
                          </Link>
                        </Grid>
                      ))
                  )}
                </Grid>
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default SimilarMerchantsProducts;
